module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/audioplayselect/asset/playGif.gif";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/audioplayselect/asset/playGif.gif
// module id = 1267
// module chunks = 367